import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-codesandbox', 'BrandCodesandbox', [["path",{"d":"M18 6H6v12h12z","key":"svg-0"}]]);